import React from 'react';
import { AvalorTableIds, isNumberType, totalCellStyle } from '@components/Table/table.utils';
import { TotalsProps } from '@components/Table/types';
import { emptyArray, emptyObject } from '@fabric-ui/utils';
import { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { generateInnerDefaultFormatter } from '@utils/utils';

interface RenderTotalsRowProps extends TotalsProps {
  displayFreeSpaceCell?: boolean;
  shouldDisplayNull: boolean;
  sx?: SxProps;
}

export const RenderTotalsRow: React.FC<RenderTotalsRowProps> = ({
  label,
  colspan,
  cells = emptyArray,
  row,
  displayFreeSpaceCell,
  shouldDisplayNull,
  sx = emptyObject,
}) => (
  <TableRow
    className="totals-row"
    sx={{
      position: 'sticky',
      bottom: 0,
      background: theme => theme.palette.white.main,
      borderTop: '1px solid',
    }}>
    {label && <TableCell sx={theme => ({ ...totalCellStyle(theme), ...sx })}>{label}</TableCell>}
    {!!(colspan && colspan > 0) && <TableCell sx={totalCellStyle} colSpan={colspan} />}
    {[...cells, ...(displayFreeSpaceCell ? [{ id: AvalorTableIds.FreeSpaceId }] : [])].map(({ id, type, options, sx = emptyObject }) => (
      <TableCell key={id} align={isNumberType(type) ? 'right' : 'left'} sx={theme => ({ ...totalCellStyle(theme), ...sx })}>
        <Box sx={{ pr: 1 }}>
          {generateInnerDefaultFormatter({
            value: options ? row[id][options.key] : row[id],
            type,
            shouldDisplayNull,
          })}
        </Box>
      </TableCell>
    ))}
  </TableRow>
);
